(function () {
    "use strict";

    angular.module('iMatApp')
        .factory("upload3DModelPermissionsService", permissionsService);

    permissionsService.$inject = ["$http"];

    function permissionsService($http) {
        var baseUrl = "/3dprint/permissions";

        return {
            getPermissions: getPermissions
        };

        function getPermissions(productTemplateId, cancelerPromise) {
            var requestUrl = baseUrl + "?productTemplateId=" + productTemplateId;
            return $http.get(requestUrl, { cache: true, canceler: cancelerPromise})
                .then(function (response) {
                    return response.data;
                });
        }
    }
}());